import React, { useState, useEffect } from "react";
import "./viewmapform.css";
import axios from "axios";
import Card from "./card";
import App from './viewmap';
import Select from 'react-select';
import Util from '../../../Common/util';
import API from '../../../Common/api';
import {

  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Modal,
  Table,
  Tooltip,
} from "reactstrap";


var url = window.location.hostname;
var port = window.location.port;
var selected_van = localStorage.getItem("selected_van");

function Maptable(props) {

  var van_obj = props.van_data.data;
  var van_list = [];
  var group_id = [];
  const [markeditems, setMarkeditems] = useState("");
  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  };

  const userName = getCookie("token");
  var bill_list = [];
  var color_list = ['map_images/location.png', 'map_images/location1.png', 'map_images/location3.png', 'map_images/location4.png', 'map_images/location5.png', 'map_images/location6.png', 'map_images/location7.png', 'map_images/location8.png', 'map_images/location9.png'];
  var color_arr = [];
  const [new_van_id, setNew_van_id] = useState("");
  const Van_id = (e) => {
    setNew_van_id(e.target.value);
  };
  
  const [new_area_code, setNew_area_code] = useState("");
  const [new_pl_group, setNew_pl_group] = useState("");
  const [new_group_id, setNew_group_id] = useState("");
  const [new_order_id, setNew_order_id] = useState("");

  var new_van_list = [{ van_name: "All", icon: 'map_images/m1.png' }];
  van_obj.map((park) => park.order_details.map((abc) => (bill_list.push({ bill: abc.bill_no, va_list: abc.van, party_list: abc.party_code, lat: abc.lat, lon: abc.lon }))));
  const [van_details, setVan_details] = useState(bill_list);

  van_obj.map((items) => (van_list.push(items.van_name), group_id.push(items.group_id)));

  var van_length = van_list.length;

  if (van_length > color_list.length) {
    for (var i = 0; i <= (Math.ceil(color_list.length / van_length)); i++) {
      color_arr = color_arr.concat(color_list);
    }
  } else {
    color_arr = color_arr.concat(color_list);
  }
  { van_list.map((van) => (new_van_list.push({ van_name: van, icon: color_arr[van_list.indexOf(van)] }))) };

  function Fetchorderdetails(selected_van) {
    url = window.location.hostname;
    port = window.location.port;

    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    } else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";
    } else {
      url = window.location.hostname + port;
    }
    const payload = {
      group_id: group_id[0],
      van_name: selected_van
    };
  
  API.post('/master_ptl/van/v1/orders/', { param: payload })
    
      .then((response) => {
        var order_details = response.data;

        let obj = order_details.data.map((item,index) => ({ icon: color_arr[van_list.indexOf(item.van_name)],marked_index:index+1,index: (van_list.indexOf(item.van_name) + 1).toString(), bill: item.bill_no, va_list: item.van_name, party_list: item.party_code, lat: item.lat, lon: item.lon, order: item.order, group_id: item.group_id, area_code: item.area_code, pl_group: item.pl_group }));

        setVan_details(obj);
        setMarkeditems("");
        

      })
      .catch(function (error) { });

  }
  const [assignLoader, setAssignLoader] = useState(false);
  const [modalNew, setModalNew] = useState(false);
  function AssignVan() {

    url = window.location.hostname;
    port = window.location.port;

    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    } else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";
    } else {
      url = window.location.hostname + port;
    }
    setAssignLoader(true);
    const payload ={
      order_id: new_order_id,
      van_id: new_van_id,
      area_code: new_area_code,
      group_id: new_group_id,
      pl_group: new_pl_group
    };
    API.post('/master_ptl/van/v1/assign/',{param:payload})
   
      .then((response) => {
        // alert(response.data.message);
        setVan_message(response.data.message);
        if (response.data.message == "Van Assigned Successfully") {
          setVanModal(false);
        }
        else {
          setVanModal(true);
        }
        setAssignLoader(false);
        setModalNew(true);
        setMarkeditems("");
        Fetchorderdetails(selected_van);

      })
      .catch(function (error) { });

  }
  const [van_message, setVan_message] = useState(null);
  const [selectedOption, setSelectedOption] = useState(selected_van);
  const Onchangehandler = e => {
    setSelectedOption(e);
    selected_van = e.van_name;
    Fetchorderdetails(selected_van);
  }
  const [vanModal, setVanModal] = useState(false);

  const handleVanAssign = (e) => {
    setVanModal(true);
    console.log("e",e);
    setNew_area_code(e.area_code);
    setNew_pl_group(e.pl_group);
    setNew_group_id(e.group_id);
    setNew_order_id(e.order);
  };
  var defaultSelectedVan = new_van_list.filter(function (el) {
    return el.van_name == selected_van
  });

  useEffect(() => { Fetchorderdetails(selected_van); }, []);
  const handleMarker = (items) => {
    setMarkeditems(items);
  };

  return (
    <Card>
      <div style={{ width: "27%", float: "left", marginTop: "4px", marginLeft: "4px" }}>
        <div className="option" style={{ width: "24.6vw", height: "8vh" }}>
          <Select
            placeholder={<div><img src= {defaultSelectedVan[0].icon} style={{width: "2.3vw", height: "4.5vh"}}></img><span style={{ marginLeft: 10 }}>{defaultSelectedVan[0].van_name}</span></div>}
            getOptionValue={(option) => option}
            options={new_van_list}
            onChange={Onchangehandler}
            formatOptionLabel={e => (
              <div style={{ alignItems: 'center' }}>
                <img src={e.icon} style={{ width: "2.3vw", height: "4.5vh" }}></img>
                <span style={{ marginLeft: 10 }}>{e.van_name}</span>

              </div>
            )}
          />
          <Modal isOpen={vanModal} backdrop="static">
            <div className="modal__header">
              <button
                className="lnr lnr-cross modal__close-btn"
                type="button"
                style={{ right: 15 }}
                onClick={() => setVanModal(false)}
              />
            </div>
            <div
              className="modal__body"
              style={{ paddingTop: 55, paddingBottom: 20 }}
            >
              <span
                className="lnr  modal__title-icon"
                style={{ color: "#4ce1b6" }}
              />
              <h5 style={{ width: '70%' }}>Enter Van Name: </h5>

              <div style={{ marginTop: 6, width: '86%' }}>
                <input type="text" className="form-control group_text1" placeholder="Enter Van Name" onChange={Van_id} />
              </div>

            </div>
            <ButtonToolbar className="modal__footer">
              <Button
                style={{ backgroundColor: "#ddd", color: "#fff", marginRight: 8 }}
                className="modal_ok"
                onClick={() => setVanModal(false)}
              >
                Cancel
              </Button>

              <Button
                style={{ backgroundColor: "#24d6a3", color: "#fff" }}
                className="modal_ok"
                onClick={AssignVan}
              // disabled={this.state.assignDisabled1}
              >
                {assignLoader && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginRight: "5px" }}
                  />
                )}

                Assign
              </Button>
            </ButtonToolbar>
          </Modal>
          <Modal isOpen={modalNew} backdrop="static">
            <div className="modal__header">
              <button
                className="lnr lnr-cross modal__close-btn"
                type="button"
                style={{ right: 15 }}
              // onClick={this.toggleNew}
              />
            </div>
            <div
              className="modal__body"
              style={{ paddingTop: 55, paddingBottom: 20 }}
            >
              <span
                className="lnr lnr-thumbs-up modal__title-icon"
                style={{ color: "#4ce1b6" }}
              />
              <h6>{van_message} </h6>
            </div>
            <ButtonToolbar className="modal__footer">
              <Button
                style={{ backgroundColor: "#24d6a3", color: "#fff" }}
                className="modal_ok"
                onClick={() => setModalNew(false)}
              >
                Ok
              </Button>
            </ButtonToolbar>
          </Modal>
          {selectedOption && <div style={{ marginTop: 9, lineHeight: '25px' }}>
            <b>Selected Option:</b> {selectedOption.van_name}
          </div>}
        </div><br></br>
        <div>
          <table className="map_table">
            <thead>
              <tr>
                <th>Sr.No</th>
                <th style={{ width: "8vw" }}>Bill No.</th>
                <th style={{ width: "8vw" }}>Van</th>
                <th style={{ width: "8vw" }}>Party Code</th>
                <th >Van change</th>

              </tr>
            </thead>
            {markeditems && <tbody className="marked_table">
              <tr><td>{markeditems.marked_index}</td><td>{markeditems.bill}</td><td>{markeditems.va_list}</td><td>{markeditems.party_list}</td><button className="van_button" style={{ marginTop: "3.5px" }} onClick={() => handleVanAssign(markeditems)}>Assign</button></tr>
            </tbody>}
            <tbody>

              {van_details.map((items, index) => <tr><td>{index + 1}</td><td>{items.bill}</td><td>{items.va_list}</td><td>{items.party_list}</td><button className="van_button" style={{ marginTop: "3.5px" }} onClick={() => handleVanAssign(items)}>Assign</button></tr>)}

            </tbody>
          </table>
        </div>
      </div>
      <div style={{ width: "72%", float: "left" }}><App data={van_details} alertmarker={handleMarker} /></div>
    </Card>
  );
};
export default Maptable;
